module.exports = ".search-input-wrapper{padding:12px}.input-search{outline:0;width:100%;background:#fff;font-size:15px}\n"